import { useEffect, useMemo, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom/cjs/react-router-dom.min';

import { createAutomationRule } from 'services/Settings';
import { toastConstant } from 'constants/toastmessage';
import {
  getWorkFlowAutomationRuleDetails,
  updateWorkFlowAutomationRules,
} from 'services/workflowAutomation/workflowAutomationRuleServices';
import { validateAutomationRule } from 'services/settings/workflowAutomation/workflowAutomationServices';
import { getTenantDetails } from 'utils/utils';
import { useToast } from 'context/ToastContext';

export default function useAutomationBuilder() {
  const history = useHistory();
  const { addToast } = useToast();
  const { automationRuleId } = useParams();
  const [automationData, setAutomationData] = useState(null);
  const [conflictErrorData, setConflictErrorData] = useState(null);

  const isEditMode = useMemo(() => Boolean(automationRuleId), [automationRuleId]);

  const getAutomationData = () => {
    const [tenantId] = getTenantDetails();
    const automationRulePk = `${tenantId}#${automationRuleId}`;
    const automationRuleSk = `automation_rule#${automationRuleId}`;
    getWorkFlowAutomationRuleDetails(automationRulePk, automationRuleSk)
      .then((res) => {
        setAutomationData(res?.data);
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const createAutomation = (formData, validationData) => {
    validateAutomationRule({ data: validationData })
      .then((res) => {
        createAutomationRule(formData)
          .then((res) => {
            history.push(`/workflow-automation`);
            addToast(
              false,
              toastConstant.toasterType.SUCCESS,
              toastConstant.api.SUCCESS,
              toastConstant?.message?.WORKFLOW_CREATION_SUCCESS
            );
          })
          .catch((err) => {
            console.log('err', err);
            addToast(
              false,
              toastConstant.toasterType.ERROR,
              toastConstant.api.FAILED,
              err?.response?.data || toastConstant?.message?.WORKFLOW_CREATION_FAILED
            );
          });
      })
      .catch((err) => {
        console.log('err', err);
        setConflictErrorData(err?.response?.data?.conflicting_rule_triggers || null);
      });
  };

  const updateAutomation = async (formData, validationData) => {
    validateAutomationRule({ data: validationData })
      .then((res) => {
        updateWorkFlowAutomationRules(false, formData)
          .then(() => {
            history.push(`/workflow-automation`);
            addToast(
              false,
              toastConstant.toasterType.SUCCESS,
              toastConstant.api.SUCCESS,
              toastConstant?.message?.WORKFLOW_UPDATION_SUCCESS
            );
          })
          .catch((err) => {
            addToast(
              false,
              toastConstant.toasterType.ERROR,
              toastConstant.api.FAILED,
              err?.response?.data || toastConstant?.message?.WORKFLOW_UPDATION_FAILED
            );
            console.log('err', err);
          });
      })
      .catch((err) => {
        console.log('err', err);
        setConflictErrorData(err?.response?.data?.conflicting_rule_triggers || null);
      });
  };

  const createOrUpdateAutomation = async (formData, validationData) => {
    if (formData?.sk || formData?.pk) {
      updateAutomation(formData, validationData);
    } else {
      createAutomation(formData, validationData);
    }
  };

  useEffect(() => {
    if (automationRuleId) {
      getAutomationData();
    }
  }, []);

  return { automationData, conflictErrorData, isEditMode, setConflictErrorData, createOrUpdateAutomation };
}
